export class CatalogInfo {
    Code: string;
    Name: string;
    ImageUrl: string;
    Blurb: string; // empty for now
}
